import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { faArrowUp, faArrowDown } from '@fortawesome/pro-solid-svg-icons';

import { DataTable } from '../../../models/data-table.model';

@Component({
  selector: 'mom-data-table',
  templateUrl: 'data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit {
  @Input() settings: DataTable;
  @Input() data: Object[];
  @Input() rowTemplates: { [key: string]: TemplateRef<unknown> };

  faArrowUp = faArrowUp;
  faArrowDown = faArrowDown;
  sortDirection: { key: string | null; direction: 'asc' | 'desc' } = { key: null, direction: 'asc' };

  ngOnInit(): void {
    this.verifySettings();
  }

  onSort(columnKey: string): void {
    if (this.sortDirection.key !== columnKey) {
      this.sortDirection = { key: columnKey, direction: 'asc' };
    } else {
      this.sortDirection.direction = this.sortDirection.direction === 'asc' ? 'desc' : 'asc';
    }

    this.data = [
      ...this.data.sort((item1, item2) => {
        if (item1[this.sortDirection.key] > item2[this.sortDirection.key]) {
          return this.sortDirection.direction === 'asc' ? 1 : -1;
        }

        if (item1[this.sortDirection.key] < item2[this.sortDirection.key]) {
          return this.sortDirection.direction === 'asc' ? -1 : 1;
        }

        return 0;
      })
    ];
  }

  private verifySettings(): void {
    if (this.settings.autoSize) {
      return;
    }

    const columnsSize = this.settings.columns.reduce((sum, current) => sum + (current.size ?? 0), 0);
    if (columnsSize > 12) {
      console.error('DataTable configured incorrectly. The summatory of the columns must be 12. This can result on the table not renering correctly.');
    }
  }
}
